import { render, staticRenderFns } from "./permissions-folder.vue?vue&type=template&id=c9124976&scoped=true&"
import script from "./permissions-folder.vue?vue&type=script&lang=js&"
export * from "./permissions-folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9124976",
  null
  
)

export default component.exports